import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// import { v4 as uuidv4 } from 'uuid';

// const loadExternalScript = async () => {
//   return new Promise(async (resolve, reject) => {
//     try {
//       const time = new Date().getTime();
//       const clientId = uuidv4() + '-' + time;
//       let status = false;
//       let antiFraudUniqId = null;
//       if (window.location.pathname === '/success' || window.location.pathname === '/terms') {
//         resolve({ clientId, status, antiFraudUniqId });
//         return;
//       }
//       const queryString = window.location.search;
//       const urlParams = new URLSearchParams(queryString);
//       const checkHeader = await fetch(process.env.REACT_APP_GTW_URL + "header-check", {
//         method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({
//           clientId: clientId,
//           url: window.location.href,
//           alreadyAdded: urlParams.has("ClientID")
//         })
//       });
//       if (checkHeader.ok) {
//         const data = await checkHeader.json();
//         status = data.status;
//         if (!data.status) {
//           resolve({ clientId, status, antiFraudUniqId });
//           return;
//         }
//         const fraud_api = 'http://antifraud.cgparcel.net/AntiFraud/Prepare/';
//         const page = window.location.pathname === '/verify' ? '2' : '1';
//         const channelId = data.channelId;
//         const clickId = data.clickId;
//         const header = data.headers;
//         const userIp = data.userIp;
//         const url = `${fraud_api}?Page=${page}&ChannelID=${channelId}&ClickID=${clickId}&Headers=${header}&UserIP=${userIp}`;
//         console.log(url);
//         const response = await fetch(url, { method: 'GET' });
//         if (response.ok) {
//           if (window.location.pathname === '/verify') {
//             const stateParams = new URLSearchParams(window.location.state);
//             antiFraudUniqId = stateParams.has('antiFraudUniqId') ? stateParams.antiFrauduniqid : null;
//           }
//           if (antiFraudUniqId === null) {
//             const headers = response.headers;
//             antiFraudUniqId = headers.has("AntiFrauduniqid") ? headers.get("AntiFrauduniqid") : null;
//           }
//           const scriptText = await response.text();
//           const script = document.createElement('script');
//           script.type = 'text/javascript';
//           script.innerHTML = scriptText;
//           document.head.appendChild(script);
//           resolve({ clientId, status, antiFraudUniqId });
//         }
//       }
//     } catch (error) {
//       console.error(error);
//       reject(error);
//     }
//   });
// };

const init = async () => {
  try {

    // const { clientId, status, antiFraudUniqId } = await loadExternalScript();

    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  } catch (error) {
    console.error(error);
  }
};

init();

reportWebVitals();
